// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-tree.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {\n  border-radius: 2px;\n  background-color: #409EFF;\n  color: #FFF;\n}", ""]);
// Exports
module.exports = exports;
